angular.module('qkr').factory('merchantShadowService', function($http, appConfig) {
	var response = function(r) {
		return r;
	};

	return {
		show: function(merchantRefId) {
            return $http.get(appConfig.apiUrl + 'vending/getMerchantShadow/' + merchantRefId).then(response, response)
		},
		create: function(id, form) {
			var payload = {
				merchantRefId: id,
				queueUrl: form.vendingQueueUrl
			};

			return $http.post(appConfig.apiUrl + 'vending/createMerchantShadow', payload).then(response, response);
		},
		update: function(id, form) {
			var payload = {
                merchantRefId: id,
                queueUrl: form.vendingQueueUrl
			};

			return $http.post(appConfig.apiUrl + 'vending/updateMerchantShadow', payload).then(response, response);
		}
	};
});



// WEBPACK FOOTER //
// ./src/services/merchantShadow.service.js